import { KlassAssessment } from '@/models/KlassAssessment';
import { StudentAssessment } from '@/models/StudentAssessment';

export enum KlassPedagogicalSheetRecordTypeEnum {
  OCCURRENCE = 'OCCURRENCE',
  ASSESSMENT = 'ASSESSMENT',
  LESSON_EVENT = 'LESSON_EVENT',
}

export enum LessonEventEnum {
  STARTED = 'STARTED',
  FINISHED = 'FINISHED',
}

export type LessonEventRecord = {
  kind: KlassPedagogicalSheetRecordTypeEnum.LESSON_EVENT;
  id: string;
  datetime: string;
  event: LessonEventEnum;
  lessonName?: string;
};

export type OccurrenceRecord = {
  kind: KlassPedagogicalSheetRecordTypeEnum.OCCURRENCE;
  id: string;
  datetime: string;
  assessment: StudentAssessment;
};

export type AssessmentRecord = {
  kind: KlassPedagogicalSheetRecordTypeEnum.ASSESSMENT;
  id: string;
  datetime: string;
  assessment: KlassAssessment;
};

export type KlassPedagogicalSheetRecord =
  | LessonEventRecord
  | OccurrenceRecord
  | AssessmentRecord;

export const ALL_RECORD_TYPES = 'ALL' as const;

export const KLASS_PEDAGOGICAL_SHEET_RECORD_FILTERS = [
  ...Object.values(KlassPedagogicalSheetRecordTypeEnum),
  ALL_RECORD_TYPES,
] as const;

export type KlassPedagogicalSheetRecordFilter =
  (typeof KLASS_PEDAGOGICAL_SHEET_RECORD_FILTERS)[number];

export const includesRecordType = (
  filter: KlassPedagogicalSheetRecordFilter,
  type: KlassPedagogicalSheetRecordTypeEnum,
) => filter === ALL_RECORD_TYPES || filter === type;
